import { FDStack } from '@facet-wealth/design';
import React from 'react';
import { FacetLogo } from './FacetLogo';

export const FreemiumNav = () => {
  return (
    <>
      <FDStack alignItems="center">
        <FacetLogo />
      </FDStack>
    </>);
};
